import React from "react";
import { useTranslation } from "react-i18next";

const RoundHistorySection = ({ session }) => {
  const { t } = useTranslation();

  if (!session.roundHistory || session.roundHistory.length === 0) {
    return null;
  }

  const summaryItems = [
    {
      label: t("history.gameHistory.totalDarts"),
      value: session.sessionSummary?.totalDarts,
    },
    {
      label: t("history.gameHistory.totalScore"),
      value: session.sessionSummary?.totalScore,
    },
    {
      label: t("history.gameHistory.avgPerRound"),
      value: session.sessionSummary?.averagePerRound,
    },
    {
      label: t("history.gameHistory.highestRound"),
      value: session.sessionSummary?.highestRound,
    },
  ];

  return (
    <div className="mt-4 sm:mt-6">
      <h3 className="text-test text-sm sm:text-base font-semibold mb-3">
        {t("history.gameHistory.roundHistory")} ({session.roundHistory.length}{" "}
        {t("history.gameHistory.rounds")})
      </h3>
      <div className="bg-secondary/30 backdrop-blur-sm rounded-lg p-3 sm:p-4">
        {/* Session Summary */}
        {session.sessionSummary && (
          <div className="mb-4 grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-4 text-xs sm:text-sm">
            {summaryItems.map((item, index) => (
              <div key={index} className="text-center">
                <p className="text-lightGray">{item.label}</p>
                <p className="text-white font-medium">{item.value}</p>
              </div>
            ))}
          </div>
        )}

        {/* Rounds Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-3 max-h-64 overflow-y-auto">
          {session.roundHistory.map((round, roundIndex) => (
            <RoundCard key={roundIndex} round={round} roundIndex={roundIndex} />
          ))}
        </div>
      </div>
    </div>
  );
};

const RoundCard = ({ round, roundIndex }) => {
  const { t } = useTranslation();

  return (
    <div className="bg-primary/60 border border-primary/30 rounded-lg p-2 sm:p-3 text-white">
      <div className="flex justify-between items-center mb-2">
        <span className="text-test text-xs sm:text-sm font-medium">
          {t("history.gameHistory.round")} {roundIndex + 1}
        </span>
        <span className="text-xs text-gray-300 bg-secondary/50 px-2 py-1 rounded-full">
          {round.totalScore}
        </span>
      </div>
      <div className="flex flex-wrap text-xs text-gray-200">
        {round.hits.map((hit, hitIndex) => (
          <span key={hitIndex} className="mr-1 mb-1">
            <span className="text-white font-medium">{hit.label}</span>
            <span className="ml-1 text-gray-400">({hit.score})</span>
            {hitIndex < round.hits.length - 1 && (
              <span className="mx-1 text-gray-600">|</span>
            )}
          </span>
        ))}
      </div>
    </div>
  );
};

export default RoundHistorySection;
